import axios from "../../../axios/index.js"
import store from "../../../../store/store.js"

// Token Refresh
let isAlreadyFetchingAccessToken = false
let subscribers = []

function onAccessTokenFetched(access_token) {
  subscribers = subscribers.filter(callback => callback(access_token))
}

function addSubscriber(callback) {
  subscribers.push(callback)
}

export default {
  init() {
    axios.interceptors.response.use(function (response) {
      return response
    }, function (error) {
      // const { config, response: { status } } = error
      const { config, response } = error
      const originalRequest = config

      // if (status === 401) {
      if (response && response.status === 401) {
        if (!isAlreadyFetchingAccessToken) {
          isAlreadyFetchingAccessToken = true
          store.dispatch("auth/fetchAccessToken")
            .then((access_token) => {
              isAlreadyFetchingAccessToken = false
              onAccessTokenFetched(access_token)
            })
        }

        const retryOriginalRequest = new Promise((resolve) => {
          addSubscriber(access_token => {
            originalRequest.headers.Authorization = 'Bearer ' + access_token
            resolve(axios(originalRequest))
          })
        })
        return retryOriginalRequest
      }
      return Promise.reject(error)
    })
  },
  login(login, pwd) {
    console.log("login", login, pwd);
    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded'
    };
    return axios.post("http://192.168.10.1/api/auth/login", "name="+login+"&pass="+pwd, { headers: headers }) 
  },
  check() {
    let uid = localStorage.getItem("uid");
    let token = localStorage.getItem("token");
    let series = localStorage.getItem("series");
    let data = "";
    data += "uid=" + uid;
    data += "&token=" + token;
    data += "&series=" + series;
    // console.log('this.$store', store);
    // console.log("check", login, pwd);
    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded'
    };
    return axios.post("http://192.168.10.1/api/auth/check", data, { headers: headers }) 
  },
  registerUser(name, email, pwd) {
    return axios.post("/api/auth/register", {displayName: name, email: email, password: pwd})
  },
  refreshToken() {
    return axios.post("/api/auth/refresh-token", {accessToken: localStorage.getItem("accessToKen")})
  }
}
